import { useState } from 'react';

export default function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [statusMsg, setStatusMsg] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('phone_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setSubmitStatus('success');
      setStatusMsg('感谢您的留言，我们会尽快回复！');
      setFormData({ name: '', email: '', subject: '', message: '' });
      setTimeout(() => { setSubmitStatus('idle'); setStatusMsg(''); }, 3000);
      return;
    }

    if (formData.message.length > 500) {
      setSubmitStatus('error');
      setStatusMsg('留言内容不能超过500个字符');
      setTimeout(() => { setSubmitStatus('idle'); setStatusMsg(''); }, 3000);
      return;
    }

    setSubmitStatus('loading');
    try {
      const params = new URLSearchParams();
      params.append('name', formData.name);
      params.append('email', formData.email);
      params.append('subject', formData.subject);
      params.append('message', formData.message);

      await fetch('https://readdy.ai/api/form/d92e1vtpggnemm8f9sj0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });

      setSubmitStatus('success');
      setStatusMsg('感谢您的留言，我们会尽快回复！');
      setFormData({ name: '', email: '', subject: '', message: '' });
      setTimeout(() => { setSubmitStatus('idle'); setStatusMsg(''); }, 3000);
    } catch {
      setSubmitStatus('error');
      setStatusMsg('发送失败，请稍后重试');
      setTimeout(() => { setSubmitStatus('idle'); setStatusMsg(''); }, 3000);
    }
  };

  const contactInfo = [
    { icon: 'ri-mail-line', label: '商务合作', value: 'hello@pxkblfc.cn' },
    { icon: 'ri-chat-smile-2-line', label: '爆料投稿', value: 'hello@pxkblfc.cn' },
    { icon: 'ri-map-pin-line', label: '公司地址', value: '北京市朝阳区望京SOHO T1 15层' },
  ];

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 mb-4 text-xs font-label font-semibold text-primary-600 bg-primary-50 rounded-full">
            联系我们
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 mb-3">
            期待您的来信
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            无论是商务合作、爆料投稿还是意见建议，都欢迎与我们联系
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-8 md:gap-10">
          {/* Contact Info Cards */}
          <div className="w-full lg:w-2/5">
            <div className="flex flex-col gap-4">
              {contactInfo.map((info, index) => (
                <div
                  key={index}
                  className="flex items-start gap-4 p-4 md:p-5 bg-background-50 rounded-lg border border-background-200/70"
                >
                  <div className="w-11 h-11 md:w-12 md:h-12 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <i className={`${info.icon} text-lg md:text-xl text-accent-600`}></i>
                  </div>
                  <div>
                    <p className="text-xs font-label text-foreground-500 mb-1">{info.label}</p>
                    <p className="text-sm md:text-base font-heading font-semibold text-foreground-900">{info.value}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-6 p-5 md:p-6 bg-background-50 rounded-lg border border-background-200/70">
              <h3 className="text-sm font-heading font-semibold text-foreground-900 mb-3">工作时间</h3>
              <div className="space-y-2 text-xs md:text-sm text-foreground-500">
                <p className="flex justify-between">
                  <span>周一至周五</span>
                  <span className="text-foreground-700">09:00 - 18:00</span>
                </p>
                <p className="flex justify-between">
                  <span>周六</span>
                  <span className="text-foreground-700">10:00 - 16:00</span>
                </p>
                <p className="flex justify-between">
                  <span>周日</span>
                  <span className="text-foreground-400">休息</span>
                </p>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="w-full lg:w-3/5">
            <form
              className="bg-background-50 rounded-lg border border-background-200/70 p-5 md:p-7"
              data-readdy-form="true"
              onSubmit={handleSubmit}
            >
              <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mb-5">
                在线留言
              </h3>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                <div>
                  <label htmlFor="about-name" className="block text-xs font-label text-foreground-600 mb-1.5">
                    您的姓名 <span className="text-accent-500">*</span>
                  </label>
                  <input
                    id="about-name"
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="请输入姓名"
                    className="w-full px-3 py-2.5 text-sm bg-background-100 border border-background-200/70 rounded-md text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-400/60 transition-colors"
                  />
                </div>
                <div>
                  <label htmlFor="about-email" className="block text-xs font-label text-foreground-600 mb-1.5">
                    电子邮箱 <span className="text-accent-500">*</span>
                  </label>
                  <input
                    id="about-email"
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="请输入邮箱"
                    className="w-full px-3 py-2.5 text-sm bg-background-100 border border-background-200/70 rounded-md text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-400/60 transition-colors"
                  />
                </div>
              </div>

              <div className="mb-4">
                <label htmlFor="about-subject" className="block text-xs font-label text-foreground-600 mb-1.5">
                  留言主题 <span className="text-accent-500">*</span>
                </label>
                <select
                  id="about-subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2.5 text-sm bg-background-100 border border-background-200/70 rounded-md text-foreground-900 outline-none focus:border-primary-400/60 transition-colors appearance-none cursor-pointer"
                >
                  <option value="">请选择留言主题</option>
                  <option value="商务合作">商务合作</option>
                  <option value="爆料投稿">爆料投稿</option>
                  <option value="意见建议">意见建议</option>
                  <option value="其他">其他</option>
                </select>
              </div>

              <div className="mb-5">
                <label htmlFor="about-message" className="block text-xs font-label text-foreground-600 mb-1.5">
                  留言内容 <span className="text-accent-500">*</span>
                  <span className="text-foreground-400 font-normal ml-2">({formData.message.length}/500)</span>
                </label>
                <textarea
                  id="about-message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  maxLength={500}
                  rows={5}
                  placeholder="请输入您的留言内容..."
                  className="w-full px-3 py-2.5 text-sm bg-background-100 border border-background-200/70 rounded-md text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-400/60 transition-colors resize-none"
                ></textarea>
              </div>

              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                className="form-hp-field"
              />

              <button
                type="submit"
                disabled={submitStatus === 'loading'}
                className="w-full py-3 bg-foreground-900 text-background-50 text-sm font-label font-semibold rounded-md hover:bg-foreground-800 disabled:opacity-50 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                {submitStatus === 'loading' ? (
                  <span className="flex items-center justify-center gap-2">
                    <i className="ri-loader-4-line animate-spin"></i>
                    发送中...
                  </span>
                ) : (
                  '提交留言'
                )}
              </button>

              {statusMsg && (
                <p className={`text-xs mt-3 text-center ${
                  submitStatus === 'error' ? 'text-red-500' : 'text-green-600'
                }`}>
                  {statusMsg}
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}